import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  actions: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.layout.gap.medium,
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& .__error': {
      flex: '1 0',
      backgroundColor: 'var(--color-danger-500)',
      color: 'var(--color-danger-050)',
      padding: theme.layout.padding.medium,
      borderRadius: 'var(--border-radius-lg)'
    }
  }
}))

function SydModalActions ({ children, className, style }) {
  const classes = useStyles()

  return (
    <div className={clsx(className, classes.actions)} style={style}>
      {children}
    </div>
  )
}

SydModalActions.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
}

export default SydModalActions
